import { formatDate } from '../../utils';

const transformRequireReviewTabPatients = ({ results = [] }) =>
  results.map(({ id, name, status, createdAt }) => ({
    id,
    name,
    medicalStatus: status,
    createdOn: formatDate(createdAt),
  }));

export default transformRequireReviewTabPatients;
